<script>
import { EmailEditor } from "vue-email-editor";
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import sample from "@/data/sample.json";
import missYouEmail from "@/data/missYouEmail.json";
import spenderEmail from "@/data/spenderEmail.json";
import welcomeEmail from "@/data/welcomeEmail.json";
import swal from "sweetalert";
export default {
  name: "add-template",
  data() {
    return {
      spinning: false,
      templateName: "",
      template: sample,
      templateId: null,
      sampleTemplate: "sample",
      templates: [
        { value: "sample", text: "Basic Template" },
        { value: "welcomeEmail", text: "Welcome Email" },
        { value: "missYouEmail", text: "Miss You Email" },
        { value: "spenderEmail", text: "Spender Email" }
      ],
      projectId: 10090,
      clone: false
    };
  },
  components: {
    EmailEditor
  },
  computed: {
    ...mapGetters(["layoutConfig"]),

    config() {
      return this.layoutConfig();
    },
    getTemplate() {
      return this.$store.getters["getTemplate"];
    },
    selectedTemplate() {
      return this.sampleTemplate;
    }
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Template Editor" }]);
    this.$store.commit("setLocationVisibile", true);
    if (this.$route.params.id) {
      // console.log(this.$route.params.id);
      this.$store.commit("setTemplateId", this.$route.params.id);
      this.$store.dispatch("getTemplate");
    }
  },
  watch: {
    getTemplate(newVal) {
      this.template = newVal ? newVal.export_html : sample;
      this.templateName = newVal ? newVal.name : "";
      this.templateId = newVal ? newVal.id : null;
      this.$refs.emailEditor.editor.loadDesign(this.template);
    }
  },
  methods: {
    editorLoaded() {
      this.$refs.emailEditor.editor.loadDesign(sample);
    },
    saveDesign() {
      this.$refs.emailEditor.editor.saveDesign(design => {
        this.$store.commit("setTemplateDesign", design);
      });
    },
    exportHtml() {
      this.$refs.emailEditor.editor.exportHtml(data => {
        this.$store.commit("setTemplateData", data);
      });
    },
    onSubmit() {
      this.saveDesign();
      this.exportHtml();
      this.$store.commit("setFormData", { templateName: this.templateName });
      this.spinning = true;
      // console.log("this.clone", this.clone);
      if (this.$route.params.id) {
        if (this.clone) {
          this.onSaveClone();
        } else {
          this.onUpdate();
        }
      } else {
        this.onSaveClone();
      }
    },
    onUpdate() {
      setTimeout(async () => {
        const response = await this.$store.dispatch("updateTemplate");
        this.spinning = false;
        if (response.id) {
          swal("Template", "Successfully updated");
        }
      }, 1000);
    },
    onSaveClone() {
      setTimeout(async () => {
        const response = await this.$store.dispatch("addTemplate");
        let flowReturn = window.localStorage.getItem("flowReturn");
        this.spinning = false;
        if (response.id) {
          if (this.clone) {
            swal("Template", "Successfully cloned");
          } else {
            swal("Template", "Successfully added");
          }
          if (flowReturn) {
            this.$router.push(`/flows/builder/${flowReturn}`);
          } else {
            this.$router.push(`/editor-template/${response.id}`);
          }
        }
      }, 1000);
    },
    onChange() {
      // console.log(this.sampleTemplate);
      if (this.sampleTemplate == "missYouEmail") {
        this.$refs.emailEditor.editor.loadDesign(missYouEmail);
      } else if (this.sampleTemplate == "spenderEmail") {
        this.$refs.emailEditor.editor.loadDesign(spenderEmail);
      } else if (this.sampleTemplate == "welcomeEmail") {
        this.$refs.emailEditor.editor.loadDesign(welcomeEmail);
      } else {
        this.$refs.emailEditor.editor.loadDesign(sample);
      }
    }
  }
};
</script>

<template>
  <div id="example">
    <div class="container">
      <div id="bar">
        <b-form
          v-on:submit.prevent="onSubmit"
          method="POST"
          accept-charset="UTF-8"
          enctype="multipart/form-data"
          id="mainForm"
        >
          <b-row>
            <b-col>
              <b-form-input
                id="input-template-name"
                v-model="templateName"
                type="text"
                required
                placeholder="Template name"
              ></b-form-input>
            </b-col>
            <b-col>
              <b-form-select
                v-model="sampleTemplate"
                :options="templates"
                @change="onChange($event)"
                required
              ></b-form-select>
            </b-col>
            <b-col class="text-right">
              <b-button variant="primary" type="submit" v-if="!spinning">
                Save Template
              </b-button>
              <b-button
                class="ml-2"
                variant="success"
                type="submit"
                v-if="!spinning"
                @click="clone = true"
              >
                Clone
              </b-button>
              <b-spinner v-show="spinning" label="Spinning"></b-spinner>
            </b-col>
          </b-row>
        </b-form>
      </div>
      <EmailEditor ref="emailEditor" v-on:load="editorLoaded" />
    </div>
  </div>
</template>

<style scoped>
#example {
  height: 100%;
}
#example .container {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
}
#bar {
  background-color: rgb(249, 249, 249);
  color: #333;
  padding: 10px;
}
</style>
